import type { DeliveryPointId } from '@/interfaces/DeliveryPoint.interface';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class DataViewerFeatureService {
    private _router = inject(Router);

    goToFeature() {
        this._router.navigate(['/', 'data-viewer']);
    }

    goToBillingList(deliveryPointIds: DeliveryPointId[]) {
        this._router.navigate(['/', 'data-viewer', 'billing'], {
            queryParams: { deliveryPointIds: JSON.stringify(deliveryPointIds) }
        });
    }
}
